import Security from '@/_helpers/security.js';
const LoginForm = () => import('@/routes_new/outer/auth/login/LoginForm');
const LoginSSO = () => import('@/routes_new/outer/auth/login/LoginServices');
// const RegistrationForm = () => import('@/routes_new/outer/auth/registration/RegistrationForm');
// const RegistrationForm = () => import('@/routes_new/outer/auth/registration');
const RecoveryPasswordToken = () => import('@/routes_new/outer/auth/recovery/RecoveryPasswordToken');
const RecoveryPasswordForm = () => import('@/routes_new/outer/auth/recovery/RecoveryPasswordForm');
const LoginTokenCheck = () => import('@/routes_new/outer/auth/login/LoginTokenCheck');

export default [
  {
    path: 'login',
    name: 'login',
    component: LoginForm,
    meta: {
      title: 'pageTitles.routes.login',
      isOuter: true
    }
  },
  {
    path: 'login-sso',
    name: 'login-sso',
    component: LoginSSO,
    meta: {
      title: 'pageTitles.routes.login',
      isOuter: true
    }
  },
  {
    path: 'password-recovery',
    name: 'password-recovery',
    component: RecoveryPasswordForm,
    props: true,
    meta: {
      title: 'pageTitles.routes.passwordRecovery',
      isOuter: true
    }
  },
  // uncomment it after delete old registration component
  // {
  //   path: 'registration',
  //   name: 'registration',
  //   props: true,
  //   component: RegistrationForm,
  //   meta: {
  //     title: 'pageTitles.routes.registration',
  //     isOuter: true
  //   }
  // },
  // TODO: :lang используется как confirm. Тоже надо полностью переделать регистрацию и/или удалить компоненты регистрации. Очень старый код.
  // {
  //   path: 'registration/:lang',
  //   name: 'registration',
  //   props: true,
  //   component: RegistrationForm,
  //   meta: {
  //     title: 'pageTitles.routes.registration',
  //     isOuter: true
  //   }
  // },
  {
    path: 'password-creation/:token',
    name: 'recover_creation',
    component: RecoveryPasswordToken,
    props(to) {
      return { token: to.params.token, first_time: true };
    },
    meta: {
      title: 'pageTitles.routes.passwordRecovery',
      isOuter: true
    }
  },
  {
    path: 'password-recovery/:token',
    name: 'recover',
    component: RecoveryPasswordToken,
    props: true,
    meta: {
      title: 'pageTitles.routes.passwordRecovery',
      isOuter: true
    }
  },
  {
    path: 'auth/once',
    name: 'login-token-check',
    component: LoginTokenCheck,
    meta: {
      isOuter: true
    }
  },
  {
    path: 'auth/:token',
    beforeEnter: Security.authorize,
    props: route => ({
      token: route.params.token,
      isOuter: true
    })
  }
];
